import { organizationServiceReq } from '@tshared/oapi/req'

const ORG_MANAGE_PATH = '/api/organization/manage/{id}' as const

export function useOrganizationQuery() {
  const user = useUser()
  return useQuery({
    queryKey: [ORG_MANAGE_PATH],
    enabled: !!user?.organization?.id,
    queryFn: async () => {
      const res = await organizationServiceReq.GET(ORG_MANAGE_PATH, {
        params: { path: { id: user?.organization?.id ?? '' } },
      })
      return res.data
    },
    staleTime: 1000 * 60 * 60 * 2,
    gcTime: 1000 * 60 * 60 * 24,
    meta: { persist: true },
  })
}
